import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
    transform(array: any, sortBy: string, order?: string): any[] {
        const sortOrder = order ? order : 'asc'; //  Setting default ascending order

        return array.sort((a, b) => {
            if (a[sortBy] < b[sortBy])
                return sortOrder == "asc" ? -1 : 1;
            else if (a[sortBy] > b[sortBy])
                return sortOrder == "asc" ? 1 : -1;
            else
                return 0
        });
    }
}
